export const personalization = {
    birthday: "Дата рождения",
    firstName: "Имя",
    lastName: "Фамилия",
    middleName: "Отчество",
    phoneNumber: "Номер телефона",
    position: "Должность",
    passport: "Паспорт",
    dateOfIssuePassport: "Дата выдачи паспорта",
    whoIssuedPassport: "Кем выдан паспорт",
    address: "Адрес",
    email: "Почта",
    name: "Наименование",
    organizationalAndLegalForm: "Организационно-правовая форма",
    registrationNumber: "Регистрационный номер",
    residentialAddress: "Адрес доставки",
    regionDelivery: "Область доставки"
}

export const CUSTOMER_PASSPORT_FIELD_KEYS = [
    "passport",
    "dateOfIssuePassport",
    "whoIssuedPassport",
];

export const CUSTOMER_PASSPORT_FIELD_DEFAULTS = {
    passport: "",
    dateOfIssuePassport: "",
    whoIssuedPassport: "",
};